import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-[#E8E6E1] bg-[#F9F7F4] mt-16">
      <div className="max-w-7xl mx-auto px-6 py-10 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 bg-[#2E5C50] rounded-md flex items-center justify-center">
              <ShieldCheck className="w-4 h-4 text-white" strokeWidth={1.5} />
            </div>
            <span className="font-heading font-bold text-base tracking-tight text-[#1C211F]">Nexari Health</span>
          </div>
          <p className="mt-3 text-sm text-[#57605A] max-w-xs">
            Track. Notify. Document. Workforce compliance automation for home-care agencies.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1C211F]">Product</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/pricing" data-testid="footer-pricing-link" className="text-[#57605A] hover:text-[#2E5C50]">Pricing</Link></li>
            <li><Link to="/auth" data-testid="footer-signin-link" className="text-[#57605A] hover:text-[#2E5C50]">Sign in</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1C211F]">Legal</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/terms" data-testid="footer-terms-link" className="text-[#57605A] hover:text-[#2E5C50]">Terms of Service</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="text-[#57605A] hover:text-[#2E5C50]">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E8E6E1] py-5 text-center text-xs text-[#57605A]">
        © {year} Nexari Health. All rights reserved.
      </div>
    </footer>
  );
}
